/*
 *   Copyright (c) 2022 Busy Human LLC
 *   All rights reserved.
 *   This file, its contents, concepts, methods, behavior, and operation  (collectively the "Software") are protected by trade secret, patent,  and copyright laws. The use of the Software is governed by a license  agreement. Disclosure of the Software to third parties, in any form,  in whole or in part, is expressly prohibited except as authorized by the license agreement.
 */
export * from "./assertions.js";
export * from "./callbacks.js";
export * from "./fulfiller.js";
export * from './instrument-panel.js';
export * from './xray.js';
export * from "./timeouts.js";
export * from "./attempt.js";
export * from "./optimist.js";
export function flattenData(data, prefix = '') {
    const tmp = {};
    for (const key in data) {
        if (data[key] !== null && typeof data[key] === 'object' && !Array.isArray(data[key]) && !('_methodName' in data[key])) {
            Object.assign(tmp, flattenData(data[key], `${prefix}${prefix ? '.' : ''}${key}`));
        }
        else {
            tmp[`${prefix}${prefix ? '.' : ''}${key}`] = data[key];
        }
    }
    return tmp;
}
//# sourceMappingURL=index.js.map